// ##### 24-09-09 Komarov
import axios from 'axios';
// ##### Komarov 2025-07-23
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// ##### 23-09-14 Komarov
// import './SearchItems.css'
import moment from 'moment';
// ##### 25-05-21 Komarov
import LoadingMessage from '../../../../Library/PageDevices/LoadingMessage';
// ##### 23-04-12 Komarov
import 'moment/locale/uk';
// ##### 23-11-02 Komarov
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import UlTag from './UlTag';
// ##### 25-01-10 Komarov
import { getUrl } from '../../../../../helpers/crypto';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../../../server/helpers/uniLog';

// ##### Komarov 2025-07-23
const ItemContent = ({ tour }) => {
  // ##### Komarov 2025-07-12
  const language = useSelector(state => state.language);
  useEffect(() => {
    moment.locale(language);
  }, [language]);
  // console.log('[TOUR]' , tour)

  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);

  const [result, setResult] = useState(false);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 25-04-30 Komarov
    uniLog(
      'axios:src/Components/Pages/SecondPageofSearchModule/Tours/ItemContent.js:ItemContent'
    );
    // ##### 25-01-10 Komarov
    const url = getUrl('content', `id=${tour.tour_id}&language=${locale}`);
    // ##### 25-04-30 Komarov
    uniLog(
      'axios:src/Components/Pages/SecondPageofSearchModule/Tours/ItemContent.js:useEffect, url:',
      url
    );
    axios
      .get(url)
      // ##### 24-11-01 Komarov
      .then(async res => {
        setResult(await res.data);
      })

      .catch(error => {
        setResult(undefined);
        // ##### 25-04-30 Komarov
        console.error('[axios error] : ', error);
      });
    //  ##### 23-04-12 Komarov
  }, [tour.tour_id, locale]);

  if (!result) {
    return (
      <div data-component="ItemContent">
        {' '}
        <LoadingMessage
          noTextMessage={true}
          loadingMessageClass={'contentLoadingWheel'}
        />
      </div>
    );
  }

  return (
    <div style={{ paddingRight: '2vw' }} data-component="ItemContent">
      {/* ##### 23-11-02 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <UlTag liSummaryWidth="50%" liImageWidth="50%" result={result} />
      </Media>
      <Media lessThan="Laptop-1024-1440">
        <UlTag liSummaryWidth="60%" liImageWidth="40%" result={result} />
      </Media>
    </div>
  );
};

export default ItemContent;
